import { Routes } from '@angular/router';
import { HomeComponent } from './components/features/home/home';
import { RequestSubmissionMethodsComponent } from './components/features/request/pages/request-submission-methods/request-submission-methods';
import { ApprovalTypeMethodComponent } from './components/features/request/pages/approval-type-method/approval-type-method';
import { ApplicantDetailsComponent } from './components/features/request/pages/applicant-details/applicant-details';
import { RequestDetailsComponent } from './components/features/request/pages/request-details/request-details';
import { TABS } from './enum/request/TABS';
import { AttachmentsComponent } from './components/features/request/pages/attachments/attachments';
import { ProductComponent } from './components/features/request/pages/product/product';
import { DeclarationsComponent } from './components/features/request/pages/declarations/declarations';
import { GeneralDetailsComponent } from './components/features/request/pages/general-details/general-details';
import { RecaptchaErrorComponent } from './components/features/request/pages/recaptcha-error/recaptcha-error';
import { ErrorComponent } from './components/features/request/pages/error/error';

export const routes: Routes = [
    {
        path: '', component: HomeComponent,
        data: { stepCondition: false, isVisibleMainHeader: false }
    },

    {
        path: 'request-submission-methods', component: RequestSubmissionMethodsComponent,
        data: { step: TABS.REQUEST_SUBMISSION_METHODS, stepCondition: false, title: 'requestSubmissionMethods', isVisibleMainHeader: false }
    },
    {
        path: 'approval-type-method', component: ApprovalTypeMethodComponent,
        data: { step: TABS.APPROVAL_TYPE_METHOD, stepCondition: true, title: 'aprrovalTypeMethod', isVisibleMainHeader: true }
    },

    {
        path: 'applicant-details', component: ApplicantDetailsComponent,
        data: { step: TABS.APPLICANT_DETAILS, stepCondition: true, title: 'applicantDetails', isVisibleMainHeader: true }
    },
    {
        path: 'general-details', component: GeneralDetailsComponent,
        data: { step: TABS.GENERAL_DETAILS, stepCondition: 'isExistTab', title: 'generalDetails', isVisibleMainHeader: true }
    }
    ,
    {
        path: 'product/:guid', component: ProductComponent,
        data: { step: TABS.PRODUCTS, stepCondition: true, title: 'products', isVisibleMainHeader: true }
    },
    {
        path: 'request-details', component: RequestDetailsComponent,
        data: { step: TABS.REQUEST_DETAILS, stepCondition: true, title: 'requestDetails', isVisibleMainHeader: true }
    }
    ,
    {
        path: 'attachments', component: AttachmentsComponent,
        data: { step: TABS.ATTACHMENTS, stepCondition: 'isExistTab', title: 'attachments', isVisibleMainHeader: true }
    }
    ,
    {
        path: 'declarations', component: DeclarationsComponent,
        data: { step: TABS.DECLARATIONS, stepCondition: 'isExistTab', title: 'declarations', isVisibleMainHeader: true }
    },
    {
        path: 'recaptcha-error', component: RecaptchaErrorComponent,
        data: { stepCondition: false, isVisibleMainHeader: false }
    }
    ,
    {
        path: 'error', component: ErrorComponent,
        data: { stepCondition: false, isVisibleMainHeader: false }
    }
];


